import { LocalConfig, NumericalConfig } from "@/config";
import { PersistContext } from "@/data/PersistProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";
import style from "./style.less";
import React from "react";

const DownloadTip = (props) => {
  const { getPersist } = React.useContext(PersistContext);
  let history = useEnhancedHistory();
  const { getLanguage, langImg, langText } = React.useContext(LanguageContext);
  const onCloseClick = () => {
    console.log("onDownloadClose");
    if (props && props.onClose && typeof props.onClose === "function") {
      props.onClose();
    }
  };
  return (
    <div class={style.outline}>
      <img
        class={style.close_btn}
        src={require("@/assets/images/download/close_btn.png").default}
        onClick={onCloseClick}
      />
      <div class={style.main_content} onClick={() => history.push(ChannelRemind("/downloadApp"))}>
        <img class={style.trophy} src={require("@/assets/images/download/trophy.png").default} />
        {/* <img class={style.trophy2} src={langImg(LocalConfig.downloadTipTextImg)} /> */}
        <div>
          <span class={style.span1}>{langText("download_title_2", {param1:LocalConfig.companyName})}</span>
          <div>
            <span class={style.span2}>{langText("download_tips_4")}</span>
            <span class={style.span3}>{NumericalConfig.addHomeScreenRewardFrom}~{NumericalConfig.addHomeScreenRewardTo}</span>
            <span class={style.span2}>{langText("download_tips_5", {param1:LocalConfig.currencyCode})}</span>
          </div>
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
          <div class={style.download_box}>
            {/* <img class={style.android} src={require("@/assets/icons/android.svg").default} /> */}
            <div class={style.download_btn_txt} style={getLanguage() == "hindi" && {fontSize:"0.5rem"}}>
              <div>{langText("download_btn_2")}</div>
              <div>{langText("download_btn_3")}</div>
            </div>
            {/* <img class={style.download_icon} src={require("@/assets/icons/download.svg").default} /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadTip;
